import { actionCreator, ActionReturnType, Loading, loadingFailed, loadingFinished, loadingIsLoading } from "@itk/typescript-utils";
import { Model_ListItemGet } from "src/backend/openapi/v1";

export enum Action {
  GetListItemsRequest = "@@ITK:SRC:COMPONENTS:FORM-LIST-ITEM-PICTURE-AUTOCOMPLETE:FORM-LIST-ITEM-PICTURE-AUTOCOMPLETE-STORE.TS:ACTION:GETLISTITEMSREQUEST",
  GetListItemsSuccess = "@@ITK:SRC:COMPONENTS:FORM-LIST-ITEM-PICTURE-AUTOCOMPLETE:FORM-LIST-ITEM-PICTURE-AUTOCOMPLETE-STORE.TS:ACTION:GETLISTITEMSSUCCESS",
  GetListItemsFail = "@@ITK:SRC:COMPONENTS:FORM-LIST-ITEM-PICTURE-AUTOCOMPLETE:FORM-LIST-ITEM-PICTURE-AUTOCOMPLETE-STORE.TS:ACTION:GETLISTITEMSFAIL"
}

type State = { listItemsState: Record<string, Loading<Model_ListItemGet[]>> };

const initialState: State = { listItemsState: {} };

export const actions = {
  getListItemsRequest: (listId: string) => actionCreator(Action.GetListItemsRequest, { listId }),
  getListItemsSuccess: (listId: string, data: Model_ListItemGet[]) => actionCreator(Action.GetListItemsSuccess, { listId, data }),
  getListItemsFail: (listId: string) => actionCreator(Action.GetListItemsFail, { listId })
};

export const formListItemPictureAutocompleteReducer = (state = initialState, action: ActionReturnType<typeof actions>): State => {
  switch (action.type) {
    case Action.GetListItemsRequest:
      return { ...state, listItemsState: { ...state.listItemsState, [action.payload.listId]: loadingIsLoading } };
    case Action.GetListItemsSuccess:
      return { ...state, listItemsState: { ...state.listItemsState, [action.payload.listId]: loadingFinished(action.payload.data) } };
    case Action.GetListItemsFail:
      return { ...state, listItemsState: { ...state.listItemsState, [action.payload.listId]: loadingFailed } };
    default:
      return state;
  }
};
